import { Routes } from '@angular/router';
import { authenticatedRouteGuards, canActivateJobPositions } from '@shared/guard/guard';
import { PageKey } from '@shared/services/page/models/page.key';

export const jobPositionRoute: Routes = [
  {
    path: 'job-positions',
    loadComponent: () => import('@job-position/pages/list/list.component').then(m => m.ListComponent),
    canActivate: [...authenticatedRouteGuards, canActivateJobPositions],
    data: {
      title: 'Funções',
      key: PageKey.JOB_POSITIONS
    }
  }
];
